import { NerveData } from '../types/emg';

export const nerveDatabase: NerveData[] = [
  // Upper Extremity - Motor
  {
    id: 'median_motor',
    name: 'Nervio Mediano - Motor (Muñeca-APB)',
    referenceValues: {
      latency: { min: 2.5, max: 4.5 },
      amplitude: { min: 4.0, max: 20.0 },
      velocity: { min: 50, max: 70 }
    }
  },
  {
    id: 'median_motor_elbow',
    name: 'Nervio Mediano - Motor (Codo-APB)',
    referenceValues: {
      latency: { min: 6.0, max: 8.5 },
      amplitude: { min: 4.0, max: 20.0 },
      velocity: { min: 50, max: 70 }
    }
  },
  {
    id: 'ulnar_motor',
    name: 'Nervio Cubital - Motor (Muñeca-ADM)',
    referenceValues: {
      latency: { min: 2.0, max: 4.0 },
      amplitude: { min: 6.0, max: 25.0 },
      velocity: { min: 50, max: 70 }
    }
  },
  {
    id: 'ulnar_motor_elbow',
    name: 'Nervio Cubital - Motor (Codo-ADM)',
    referenceValues: {
      latency: { min: 6.5, max: 9.0 },
      amplitude: { min: 6.0, max: 25.0 },
      velocity: { min: 50, max: 70 }
    }
  },
  {
    id: 'radial_motor',
    name: 'Nervio Radial - Motor (Antebrazo-EIP)',
    referenceValues: {
      latency: { min: 2.5, max: 4.0 },
      amplitude: { min: 2.0, max: 15.0 },
      velocity: { min: 45, max: 65 }
    }
  },
  {
    id: 'axillary',
    name: 'Nervio Axilar - Motor',
    referenceValues: {
      latency: { min: 2.0, max: 4.0 },
      amplitude: { min: 3.0, max: 15.0 },
      velocity: { min: 50, max: 65 }
    }
  },
  {
    id: 'musculocutaneous',
    name: 'Nervio Musculocutáneo - Motor',
    referenceValues: {
      latency: { min: 2.5, max: 4.5 },
      amplitude: { min: 3.5, max: 16.0 },
      velocity: { min: 50, max: 65 }
    }
  },
  {
    id: 'suprascapular',
    name: 'Nervio Supraescapular - Motor',
    referenceValues: {
      latency: { min: 2.5, max: 4.5 },
      amplitude: { min: 2.0, max: 12.0 },
      velocity: { min: 45, max: 60 }
    }
  },
  {
    id: 'accessory',
    name: 'Nervio Accesorio Espinal - Motor',
    referenceValues: {
      latency: { min: 1.5, max: 3.5 },
      amplitude: { min: 2.5, max: 14.0 },
      velocity: { min: 50, max: 70 }
    }
  },
  {
    id: 'facial_motor',
    name: 'Nervio Facial - Motor (Nasalis/Orbicular)',
    referenceValues: {
      latency: { min: 2.0, max: 4.5 },
      amplitude: { min: 1.0, max: 8.0 },
      velocity: { min: 40, max: 65 }
    }
  },

  // Upper Extremity - Sensory
  {
    id: 'median_sensory',
    name: 'Nervio Mediano - Sensitivo (Dedo II-Muñeca)',
    referenceValues: {
      latency: { min: 2.0, max: 3.5 },
      amplitude: { min: 15, max: 50 },
      velocity: { min: 50, max: 70 }
    }
  },
  {
    id: 'median_sensory_palm',
    name: 'Nervio Mediano - Sensitivo (Palma-Muñeca)',
    referenceValues: {
      latency: { min: 1.5, max: 2.5 },
      amplitude: { min: 20, max: 80 },
      velocity: { min: 45, max: 65 }
    }
  },
  {
    id: 'ulnar_sensory',
    name: 'Nervio Cubital - Sensitivo (Dedo V-Muñeca)',
    referenceValues: {
      latency: { min: 2.0, max: 3.2 },
      amplitude: { min: 10, max: 40 },
      velocity: { min: 50, max: 70 }
    }
  },
  {
    id: 'radial_sensory',
    name: 'Nervio Radial - Sensitivo (Dorso mano-Antebrazo)',
    referenceValues: {
      latency: { min: 2.0, max: 3.5 },
      amplitude: { min: 8, max: 30 },
      velocity: { min: 45, max: 65 }
    }
  },
  {
    id: 'median_ulnar_mixed_palm_wrist',
    name: 'Comparativa Mixta Mediano-Cubital (Palma-Muñeca)',
    referenceValues: {
      latency: { min: 1.2, max: 2.2 },
      amplitude: { min: 20, max: 100 },
      velocity: { min: 45, max: 70 }
    }
  },

  // Lower Extremity - Motor
  {
    id: 'peroneal_motor',
    name: 'Nervio Peroneo Común - Motor (Tobillo-EDB)',
    referenceValues: {
      latency: { min: 2.5, max: 5.8 },
      amplitude: { min: 2.0, max: 15.0 },
      velocity: { min: 40, max: 60 }
    }
  },
  {
    id: 'peroneal_motor_knee',
    name: 'Nervio Peroneo Común - Motor (Rodilla-EDB)',
    referenceValues: {
      latency: { min: 9.0, max: 14.0 },
      amplitude: { min: 2.0, max: 15.0 },
      velocity: { min: 40, max: 60 }
    }
  },
  {
    id: 'tibial_motor',
    name: 'Nervio Tibial - Motor (Tobillo-Abductor Hallucis)',
    referenceValues: {
      latency: { min: 3.0, max: 6.0 },
      amplitude: { min: 5.0, max: 25.0 },
      velocity: { min: 40, max: 60 }
    }
  },
  {
    id: 'tibial_motor_knee',
    name: 'Nervio Tibial - Motor (Rodilla-Abductor Hallucis)',
    referenceValues: {
      latency: { min: 13.0, max: 18.0 },
      amplitude: { min: 5.0, max: 25.0 },
      velocity: { min: 40, max: 60 }
    }
  },
  {
    id: 'femoral',
    name: 'Nervio Femoral - Motor',
    referenceValues: {
      latency: { min: 4.0, max: 6.5 },
      amplitude: { min: 3.0, max: 15.0 },
      velocity: { min: 45, max: 60 }
    }
  },
  {
    id: 'sciatic',
    name: 'Nervio Ciático - Motor',
    referenceValues: {
      latency: { min: 4.5, max: 7.0 },
      amplitude: { min: 2.5, max: 12.0 },
      velocity: { min: 40, max: 55 }
    }
  },

  // Lower Extremity - Sensory
  {
    id: 'sural_sensory',
    name: 'Nervio Sural - Sensitivo (Pantorrilla-Tobillo)',
    referenceValues: {
      latency: { min: 2.0, max: 4.2 },
      amplitude: { min: 5, max: 25 },
      velocity: { min: 40, max: 60 }
    }
  },
  {
    id: 'peroneal_superficial_sensory',
    name: 'Nervio Peroneo Superficial - Sensitivo',
    referenceValues: {
      latency: { min: 2.5, max: 4.5 },
      amplitude: { min: 3, max: 20 },
      velocity: { min: 40, max: 60 }
    }
  },
  {
    id: 'saphenous_sensory',
    name: 'Nervio Safeno - Sensitivo',
    referenceValues: {
      latency: { min: 2.0, max: 4.0 },
      amplitude: { min: 2, max: 15 },
      velocity: { min: 40, max: 55 }
    }
  },
  {
    id: 'lateral_femoral_cutaneous',
    name: 'Nervio Femorocutáneo Lateral - Sensitivo',
    referenceValues: {
      latency: { min: 2.5, max: 4.5 },
      amplitude: { min: 3.0, max: 20.0 },
      velocity: { min: 45, max: 60 }
    }
  },

  // Legacy entries for backward compatibility (keeping original names)
  {
    id: 'peroneal',
    name: 'Peroneo',
    referenceValues: {
      latency: { min: 3.0, max: 5.0 },
      amplitude: { min: 2.0, max: 10.0 },
      velocity: { min: 40, max: 55 }
    }
  },
  {
    id: 'tibial',
    name: 'Tibial',
    referenceValues: {
      latency: { min: 3.0, max: 5.0 },
      amplitude: { min: 2.0, max: 10.0 },
      velocity: { min: 40, max: 55 }
    }
  },
  {
    id: 'sural',
    name: 'Sural',
    referenceValues: {
      latency: { min: 2.0, max: 4.0 },
      amplitude: { min: 5.0, max: 30.0 },
      velocity: { min: 40, max: 55 }
    }
  },
  {
    id: 'superficial_peroneal',
    name: 'Peroneo Superficial',
    referenceValues: {
      latency: { min: 2.2, max: 4.2 },
      amplitude: { min: 4.0, max: 25.0 },
      velocity: { min: 40, max: 55 }
    }
  },
  {
    id: 'saphenous',
    name: 'Safeno',
    referenceValues: {
      latency: { min: 2.8, max: 5.0 },
      amplitude: { min: 2.0, max: 15.0 },
      velocity: { min: 40, max: 55 }
    }
  }
];

// ============================================================================
// Referencias NCS — fuente única (Sprint 2)
// ============================================================================

export type NerveReferenceRange = NerveData['referenceValues'];

/** Alias clínico → IDs canónicos en nerveDatabase */
export const NERVE_CANONICAL_IDS: Record<string, { motor: string; sensory: string }> = {
  median: { motor: 'median_motor', sensory: 'median_sensory' },
  mediano: { motor: 'median_motor', sensory: 'median_sensory' },
  ulnar: { motor: 'ulnar_motor', sensory: 'ulnar_sensory' },
  cubital: { motor: 'ulnar_motor', sensory: 'ulnar_sensory' },
  radial: { motor: 'radial_motor', sensory: 'radial_sensory' },
  peroneal: { motor: 'peroneal_motor', sensory: 'peroneal_superficial_sensory' },
  peroneo: { motor: 'peroneal_motor', sensory: 'peroneal_superficial_sensory' },
  fibular: { motor: 'peroneal_motor', sensory: 'peroneal_superficial_sensory' },
  tibial: { motor: 'tibial_motor', sensory: 'sural_sensory' },
  sural: { motor: 'tibial_motor', sensory: 'sural_sensory' },
  saphenous: { motor: 'tibial_motor', sensory: 'saphenous_sensory' },
  safeno: { motor: 'tibial_motor', sensory: 'saphenous_sensory' },
};

/** Claves legacy usadas por utils/analysis.ts y store NCS */
export const LEGACY_NERVE_REFERENCE_IDS: Record<string, string> = {
  median: 'median_motor',
  ulnar: 'ulnar_motor',
  peroneal: 'peroneal_motor',
  tibial: 'tibial_motor',
  sural: 'sural_sensory',
  radial: 'radial_motor',
};

export function normalizeNerveLabel(value: string): string {
  return value
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[_-]/g, ' ')
    .trim();
}

export function getNerveById(id: string): NerveData | undefined {
  return nerveDatabase.find(n => n.id === id);
}

function resolveCanonicalId(nerveName: string, type?: 'motor' | 'sensory'): string | undefined {
  const normalized = normalizeNerveLabel(nerveName);
  for (const [alias, ids] of Object.entries(NERVE_CANONICAL_IDS)) {
    if (normalized === alias || normalized.includes(alias)) {
      if (type) return ids[type];
      if (normalized.includes('sensitiv') || normalized.includes('sensorial')) return ids.sensory;
      if (normalized.includes('motor')) return ids.motor;
      return ids.motor;
    }
  }
  return undefined;
}

/** Busca entrada en nerveDatabase por nombre o alias */
export function findNerveEntry(
  nerveName: string,
  type?: 'motor' | 'sensory'
): NerveData | undefined {
  const canonicalId = resolveCanonicalId(nerveName, type);
  if (canonicalId) {
    const byId = getNerveById(canonicalId);
    if (byId) return byId;
  }

  const normalized = normalizeNerveLabel(nerveName);
  return nerveDatabase.find(nerve => {
    const id = normalizeNerveLabel(nerve.id);
    const name = normalizeNerveLabel(nerve.name);
    const simplifiedName = name
      .replace(/^nervio\s+/, '')
      .replace(/\s+motor.*$/, '')
      .replace(/\s+sensitiv.*$/, '');

    if (type === 'motor' && !name.includes('motor') && !id.includes('motor')) return false;
    if (type === 'sensory' && !name.includes('sensitiv') && !id.includes('sensory')) return false;

    return (
      normalized === id ||
      normalized === name ||
      normalized.includes(id) ||
      normalized.includes(simplifiedName) ||
      name.includes(normalized)
    );
  });
}

export function getReferenceRangeForNerve(
  nerveName: string,
  type: 'motor' | 'sensory' = 'motor'
): NerveReferenceRange | null {
  return findNerveEntry(nerveName, type)?.referenceValues ?? null;
}

/** Mapa legacy para utils/analysis.ts — derivado de nerveDatabase */
export function buildLegacyNerveReferences(): Record<
  string,
  { name: string; latency: { min: number; max: number }; velocity: { min: number; max: number }; amplitude: { min: number; max: number } }
> {
  const out: Record<string, { name: string; latency: { min: number; max: number }; velocity: { min: number; max: number }; amplitude: { min: number; max: number } }> = {};
  for (const [key, id] of Object.entries(LEGACY_NERVE_REFERENCE_IDS)) {
    const entry = getNerveById(id);
    if (!entry) continue;
    out[key] = {
      name: entry.name,
      ...entry.referenceValues,
    };
  }
  return out;
}

function rv(id: string): NerveReferenceRange {
  const entry = getNerveById(id);
  if (!entry) throw new Error(`nerveDatabase: entrada requerida no encontrada (${id})`);
  return entry.referenceValues;
}

/** Rangos normales clínicos — derivados de nerveDatabase (NCS) + constantes de estudios especiales */
export const NORMAL_REFERENCE_VALUES = {
  upperLimb: {
    motor: {
      median: {
        latency: { max: rv('median_motor').latency.max },
        amplitude: { min: rv('median_motor').amplitude.min },
        velocity: { min: rv('median_motor').velocity.min },
      },
      ulnar: {
        latency: { max: rv('ulnar_motor').latency.max },
        amplitude: { min: rv('ulnar_motor').amplitude.min },
        velocity: { min: rv('ulnar_motor').velocity.min },
      },
    },
    sensory: {
      median: {
        peakLatency: { max: rv('median_sensory').latency.max },
        amplitude: { min: rv('median_sensory').amplitude.min },
        velocity: { min: rv('median_sensory').velocity.min },
      },
      ulnar: {
        peakLatency: { max: rv('ulnar_sensory').latency.max },
        amplitude: { min: rv('ulnar_sensory').amplitude.min },
        velocity: { min: rv('ulnar_sensory').velocity.min },
      },
    },
  },
  lowerLimb: {
    motor: {
      tibial: {
        latency: { max: rv('tibial_motor').latency.max },
        amplitude: { min: rv('tibial_motor').amplitude.min },
        velocity: { min: rv('tibial_motor').velocity.min },
      },
      peroneal: {
        latency: { max: rv('peroneal_motor').latency.max },
        amplitude: { min: rv('peroneal_motor').amplitude.min },
        velocity: { min: rv('peroneal_motor').velocity.min },
      },
    },
    sensory: {
      sural: {
        peakLatency: { max: rv('sural_sensory').latency.max },
        amplitude: { min: rv('sural_sensory').amplitude.min },
        velocity: { min: rv('sural_sensory').velocity.min },
      },
    },
  },
  /** Estudios especiales — no viven en nerveDatabase */
  fWave: {
    median: { maxLatency: 31 },
    ulnar: { maxLatency: 32 },
    tibial: { maxLatency: 56 },
    peroneal: { maxLatency: 56 },
    persistence: { min: 80 },
    chronodispersion: {
      upperLimb: { max: 4 },
      lowerLimb: { max: 6 },
    },
  },
  hReflex: {
    soleus: { maxLatency: 34 },
    hmRatio: { max: 50 },
    sideToDifference: { max: 1.5 },
  },
  rns: {
    decrement: { abnormalThreshold: 10 },
    increment: { lambertEatonThreshold: 100 },
  },
} as const;